<agr-page-toolbar [pageTitle]="'app.customer.navigation.locations' | translate">
  <ng-container actions>
    <agr-primary-action
      actionIcon="add"
      [actionText]="'add' | translate"
      (click)="add()"
      onkeypress="add()"
      data-test="location__add"
    ></agr-primary-action>
  </ng-container>
</agr-page-toolbar>
<section data-test="locations">
  <ng-container [agrBlockSpinner]="(locations$ | async) === undefined">
    @if (customerId$ | async; as customerId) {
      <div>
        @if ((locations$ | async)?.length === 0) {
          <div class="wrapper--spacing-horizontal">
            <agr-notification-empty
              emptyTitle="{{ 'app.no_results_title' | translate }}"
              emptyDescription="{{ 'app.no_results_description' | translate }}"
              [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
            ></agr-notification-empty>
          </div>
        } @else {
          <mat-nav-list>
            @for (location of locations$ | async; track location) {
              <a
                href="#"
                mat-list-item
                data-test="location-overview__item"
                class="listItem"
                [routerLink]="['/customer', customerId, 'location', location.id]"
              >
                <mat-icon matListItemAvatar class="list-avatar">perm_identity</mat-icon>
                <div matListItemTitle class="text--h3" data-test="location-overview-item__name">
                  {{ location.name }}
                </div>
                <div
                  matListItemLine
                  class="text--gray"
                  data-test="location-overview-item__adresLineI"
                >
                  {{ location.street }} {{ location.houseNumber }}
                  {{ location.houseNumberAddition }}
                </div>
                <div
                  matListItemLine
                  class="text--gray"
                  data-test="location-overview-item__adresLineII"
                >
                  {{ location.postalCode }} {{ location.city }},
                  {{ 'app.countries.' + location.country | translate }}
                </div>
                <div matListItemLine class="text--gray">
                  @if (location.phoneNumber) {
                    <span class="spacing--margin-right" data-test="location-overview-item__phone"
                      ><mat-icon class="text--small">phone</mat-icon
                      >{{ location.phoneNumber }}</span
                    >
                  }
                  @if (location.mobileNumber) {
                    <span class="spacing--margin-right" data-test="location-overview-item__mobile"
                      ><mat-icon class="text--small">phone_android</mat-icon
                      >{{ location.mobileNumber }}</span
                    >
                  }
                </div>
                <button
                  matListItemMeta
                  mat-icon-button
                  class="delete-button"
                  (click)="delete($event, location.id)"
                >
                  <mat-icon iconPositionEnd>delete_permanently</mat-icon>
                </button>
              </a>
            }
            <mat-divider></mat-divider>
          </mat-nav-list>
        }
      </div>
    }
  </ng-container>
</section>
